import { render, staticRenderFns } from "./LocationCommentaryDialog.vue?vue&type=template&id=3d82386a&scoped=true&"
import script from "./LocationCommentaryDialog.vue?vue&type=script&lang=ts&"
export * from "./LocationCommentaryDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d82386a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
